import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import ProdMachineTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import machineIcon from "../../../../../assets/new-product-detail-cats/sub-icons/prod-machine-icon.svg";

const ProdMachineContents = ({ productId, systemBoundaryProps }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false);
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-energy-contents">
      <SubHeaderBox
        subTitle={t("PRODUCT_MACHINES_EQUIPMENT")}
        number={"12.2C"}
        isNormal={true}
        systemBoundaryProps={systemBoundaryProps}
        showSystemBoundary={false}
        icon={machineIcon}
      />
      {shouldShowTable && <ProdMachineTable productId={productId} />}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default ProdMachineContents;
